export const AuthEndpoints = {
    login: `/auth/login`,
    logout: `/auth/logout`,
    refreshToken: `/auth/refreshtoken`,
}
